import { createAction, props } from '@ngrx/store';
import { ConnectionStatus } from '../model/realtime.model';

export const realtimeStatusUpdate = createAction(
  '[RealTime] Status update',
  props<{ status: ConnectionStatus }>(),
);
